import React from 'react';
import { Button, Row, Col, Tooltip } from 'antd';
import {
  EyeOutlined,
  HistoryOutlined,
} from '@ant-design/icons';

import { CustomTable, GeneralContainer } from '../../../../components';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import { TransfersResponse } from '../../../Transfers/types/transfers-response';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';

interface InventoryViewProps {
  data?: TransfersResponse;
  onViewCreate: () => void;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  onManageDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
  supervisors?: ShareResponse[];
  setIsModalCustomFilter?: any;
  movements?: any[];
}

const InventoryView: React.FC<InventoryViewProps> = ({
  data,
  onManageDetail,
  onViewDetail,
  onPagination,
  formik,
  states,
  isLoading,
  onResetFilters,
}) => {
  const columns = [
    {
      title: 'Número ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Tipo ticket',
      dataIndex: 'ticket_type',
      key: 'ticket_type',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'query_date',
      key: 'query_date',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Estado de solicitud',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status: string) => {
        return <CustomAlert status={status} />
      },
    },
    {
      title: 'Solicitante',
      dataIndex: 'requester',
      key: 'requester',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      align: 'center',
      width: 300,
      render: (text: string) => (
        <Tooltip title={text || 'Sin registro'}>
          <div
            style={{
              maxWidth: 250,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              margin: '0 auto',
            }}
          >
            {text || 'Sin registro'}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (value: any) => (
        <>
          {value.status_id !== 8 && (
            <Tooltip title="Ver solicitud">
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => onViewDetail(value.id.toString())}
              />
            </Tooltip>
          )}
          {value.status_id === 8 && (
            <Tooltip title="Gestionar solicitud">
              <Button
                type="link"
                style={{ marginLeft: 8 }}
                icon={<HistoryOutlined />}
                onClick={() => onManageDetail(value.id.toString())}
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  return (
    <GeneralContainer title="Traslados por recibir" isLoading={isLoading}>
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            loading={isLoading}
            columns={columns as any}
            dataSource={data?.data}
            paginationConfig={{
              current: data?.current_page,
              pageSize: data?.per_page,
              total: data?.total,
              onChange: onPagination,
            }}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </GeneralContainer>
  );
};

export default InventoryView;
